import React from "react";
import ContactBox from "../components/ContactBox";
import { Link } from "react-router-dom";

const Contact = () => {
  return (
    <>
      <main className="main-content site-wrapper-reveal">
        <section
          className="page-content-area "
          data-bg-img="assets/img/photos/bg-page-title.webp"
          style={{
            backgroundImage: `url("../../assets/img/product_img_cover.jpg")`,
          }}
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="page-title-content text-center">
                  <h1 className="title">Contact Us</h1>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="contact-modern-area section-space">
          <div className="container shadow-lg overflow-hidden rounded-4">
            <div className="row g-0 premium-contact-wrapper">
              {/* LEFT SIDE: Showroom & Admin */}
              <div className="col-lg-7">
                <div className="contact-panel-dark h-100 p-4 d-flex flex-column justify-content-center">
                  <div className="panel-content">
                    <span className="panel-label">
                      Visit Our Experience Center
                    </span>
                    <h2 className="panel-title mt-2">
                      Showroom & Adm. Office <br />
                      
                    </h2>

                    <div className="address-block d-flex align-items-start mb-2">
                      <div className="icon-box me-3">
                        <i className="fa fa-map-marker-alt"></i>
                      </div>
                      <p className="mb-0">
                        <strong>1st Floor, Sachi House,</strong>
                        <br />
                        Above Patel Ice Cream, Commerce Six Road,
                        <br />
                        Navrangpura, Ahmedabad,
                        Gujarat.
                        <br/>
                      </p>
                    </div>

                    <div className="contact-footer border-top">
                      <div className="contact-link-group d-flex align-items-center  mt-2">
                        <i className="fa fa-phone-alt me-3"></i>
                        <div className="links">
                          <a
                            href="tel:+919824595370 "
                            className="text-decoration-none"
                          >
                            +91 9662917174 / 9824595370 
                          </a>
                        </div>
                      </div>
                      <div className="contact-link-group d-flex align-items-center mb-3">
                        <i className="fa fa-phone-alt me-3"></i>
                        <div className="links">
                          <a
                            href="tel:+07926442095 / 96"
                            className="text-decoration-none"
                          >
                            079 - 26442095 / 96
                          </a>
                        </div>
                      </div>

                      <div className="contact-link-group d-flex align-items-center">
                        <i className="fa fa-envelope-open me-3"></i>
                        <div className="links d-flex flex-column">
                          <a
                            href="mailto:sales@sachiproducts.com"
                            className="text-decoration-none"
                          >
                            sales@sachiproducts.com
                          </a>
                          <a
                            href="mailto:info@sachiproducts.com"
                            className="text-decoration-none"
                          >
                            info@sachiproducts.com
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* RIGHT SIDE: Works & Packaging */}
              <div className="col-lg-5">
                <div className="contact-panel-light h-100 p-4 p-md-5 d-flex flex-column justify-content-center mt-2">
                  {/* <div className="panel-content text-center text-lg-start">
                    <h3 className="sub-panel-title mb-4">
                      Packaging Division Office
                    </h3>

                    <div className="address-block d-flex align-items-start mb-4">
                      <div className="icon-box me-3">
                        <i className="fa fa-map-marker-alt"></i>
                      </div>
                      <p className="mb-0">
                        <strong> G-7, Ravi Estate, Dudheswar,</strong>
                        <br />
                       Ahmedabad,Gujarat.
                       
                      </p>
                    </div>

                    <div className="phone-stack py-3 px-4 bg-light rounded-3 shadow-sm">
                      <div className="phone-row d-flex justify-content-between mb-2">
                        <span className="fw-bold text-muted">Tel:</span>
                        <a
                          href="tel:+ 07925625184"
                          className="text-dark text-decoration-none"
                        >
                         079-25625184/85
                        </a>
                      </div>
                      <hr />
                      <div className="phone-row d-flex justify-content-between">
                        <span className="fw-bold text-muted">Mobile:</span>
                        <a
                          href="tel:+919537557989"
                          className="gold-text fw-bold text-decoration-none"
                        >
                          +91 9537557989
                        </a>
                      </div>
                    </div>
                  </div> */}
                   <div className="panel-content">
                    <h2 className="panel-title">
                     Packaging Division Office<br />
                      
                    </h2>

                   <div className="address-block d-flex align-items-start">
                      <div className="icon-box me-3">
                        <i className="fa fa-map-marker-alt"></i>
                      </div>
                      <p className="mb-0">
                        <strong> G-7, Ravi Estate, Dudheswar,</strong>
                        <br />
                       Ahmedabad,<br/>
                       Gujarat.
                       
                      </p>
                    </div>

                    <div className="contact-footer border-top">
                      <div className="contact-link-group d-flex align-items-center mt-2">
                        <i className="fa fa-phone-alt me-3"></i>
                        <div className="links">
                         <a
                          href="tel:+919537557989"
                          className="gold-text text-decoration-none"
                        >
                          +91 9537557989
                        </a>
                        </div>
                      </div>
                      <div className="contact-link-group d-flex align-items-center mb-3">
                        <i className="fa fa-phone-alt me-3"></i>
                        <div className="links">
                          <a
                          href="tel:+ 07925625184"
                          className="text-dark text-decoration-none"
                        >
                         079-25625184 / 85
                        </a>
                        </div>
                      </div>

                      {/* <div className="contact-link-group d-flex align-items-center">
                        <i className="fa fa-envelope-open me-3"></i>
                        <div className="links d-flex flex-column">
                          <a
                            href="mailto:sales@sachiproducts.com"
                            className="text-decoration-none"
                          >
                            sales@sachiproducts.com
                          </a>
                          <a
                            href="mailto:info@sachiproducts.com"
                            className="text-decoration-none"
                          >
                            info@sachiproducts.com
                          </a>
                        </div>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className="container-fluid">
          <div className="contact-map-area pt-80">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4517.723973184111!2d72.5546118!3d23.0403956!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e85c1db177071%3A0x5e16ca356773e748!2sSachi%20Products!5e1!3m2!1sen!2sin!4v1762424301314!5m2!1sen!2sin"
              width="600"
              height="450"
              style={{ border: "0px" }}
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </main>
    </>
  );
};
export default Contact;
